
    import { Component, Vue } from 'vue-property-decorator';
    import { ITagType } from '@/interfaces/Tags/ITagType';
    import { ITag } from '@/interfaces/Tags/ITag';
    import tagsAPI from '@/store/tagsAPI';

    @Component
    export default class Tags extends Vue {
        private drpTagType = [] as Array<ITagType>;
        TagTypeIdSelected: number = 0;
        private tags = [] as Array<ITag>;
        private async onchangeselect() {
            if (this.TagTypeIdSelected > 0) {
                this.tags = await tagsAPI.getTags(this.TagTypeIdSelected);
            }               
        }
        private async edittag(id: number) {
            if (this.TagTypeIdSelected > 0) {
                this.$router.push({ path: "/Tags/edit/" + this.TagTypeIdSelected + "/" + id });
            }
        }
        
        private async deletetag(id: number) {
            if (this.TagTypeIdSelected > 0) {
                if (confirm("Are you sure you want to delete the Tag?")) {
                    await tagsAPI.deletetag(id).then((result) => {
                        
                            console.log(result);
                            this.onchangeselect();
                       
                    });
                }
           }
        }
        private async mounted() {
            try {
                this.drpTagType = await tagsAPI.getTagType();

                if (this.$route.params.tagtypeid != undefined) {
                    this.TagTypeIdSelected = Number(this.$route.params.tagtypeid);
                    this.onchangeselect();
                }
            } catch (error) {
                // this.loadingFailed = true;
                // this.errorMessage = '';
            } finally {
                // this.loading = false;
            }
        }
    }
